import AdminAPI from 'config/api/AdminAPI';
import { APPROVED_STATUS_SLUG, getFFLObj } from 'helpers/DataHelper';
import { notify } from 'helpers/NotifyHelper';
import { t } from 'i18next';
import apiService from 'services/api.service';
import { manageAPICall } from 'store/auth/actions/CommonCrudAction';

export const getFFLCounter = async () => {
  const response = await manageAPICall(AdminAPI.fflCounter.url, AdminAPI.fflCounter.method, {});
  return response;
};
export const getFFLProfileInfo = async (token = null) => {
  let response;
  if (token) {
    response = response = await apiService.getPublicTokenData(
      AdminAPI.getFFLProfile.url,
      {},
      token
    );
  } else {
    response = await manageAPICall(AdminAPI.getFFLProfile.url, AdminAPI.getFFLProfile.method, {});
  }
  return response;
};
export const updateFFLProfileDetails = async (data: object) => {
  const response = await manageAPICall(
    AdminAPI.updateFFLProfile.url,
    AdminAPI.updateFFLProfile.method,
    data
  );
  return response;
};

export const connectPaymentGateway = async (data: object) => {
  const response = await manageAPICall(
    AdminAPI.connectPaymentGateway.url,
    AdminAPI.connectPaymentGateway.method,
    data
  );
  return response;
};

export const disconnectPaymentGateway = async (data: object) => {
  const response = await manageAPICall(
    AdminAPI.disconnectPaymentGateway.url,
    AdminAPI.disconnectPaymentGateway.method,
    data
  );
  return response;
};

export const connectShippingCarrier = async (data: object) => {
  const response = await manageAPICall(
    AdminAPI.connectShippingCarrier.url,
    AdminAPI.connectShippingCarrier.method,
    data
  );
  return response;
};

export const disconnectShippingCarrier = async (data: object) => {
  const response = await manageAPICall(
    AdminAPI.disconnectShippingCarrier.url,
    AdminAPI.disconnectShippingCarrier.method,
    data
  );
  return response;
};

export const verifyFFLLicence = async (data: object) => {
  const response = await manageAPICall(
    AdminAPI.verifyFFLLicence.url,
    AdminAPI.verifyFFLLicence.method,
    data
  );
  return response;
};
export const getAllFFL = async (data: object) => {
  const response = await manageAPICall(AdminAPI.fflList.url, AdminAPI.fflList.method, data);
  return response;
};

export const getSingleFFLProfileInfo = async (data: object) => {
  const response = await manageAPICall(
    AdminAPI.singleFFLInfo.url,
    AdminAPI.singleFFLInfo.method,
    data
  );
  return response;
};

export const updateFFLInfo = async (data: object) => {
  const response = await manageAPICall(AdminAPI.updateFFL.url, AdminAPI.updateFFL.method, data);
  return response;
};

export const deleteFFL = async (data: object) => {
  const response = await manageAPICall(AdminAPI.deleteFFL.url, AdminAPI.deleteFFL.method, data);
  return response;
};

export const verifyFFLAccount = async (data: object) => {
  const response = await manageAPICall(AdminAPI.verifyFFL.url, AdminAPI.verifyFFL.method, data);
  return response;
};
export const exportFFLData = async (data: object) => {
  const response = await manageAPICall(
    AdminAPI.exportFFLData.url,
    AdminAPI.exportFFLData.method,
    data
  );
  return response;
};
export const updateFFLFastBoundData = async (data: object) => {
  const response = await manageAPICall(
    AdminAPI.updateFFLFastBound.url,
    AdminAPI.updateFFLFastBound.method,
    data
  );
  return response;
};
export const getFFLFastBoundSetting = async (data: object) => {
  const response = await manageAPICall(
    AdminAPI.getFFLFastBoundSetting.url,
    AdminAPI.getFFLFastBoundSetting.method,
    data
  );
  return response;
};
// upload album image
export const uploadAlbumimages = async (data: object) => {
  const response = await manageAPICall(
    AdminAPI.uploadAlbumimages.url,
    AdminAPI.uploadAlbumimages.method,
    data
  );
  return response;
};
// delete image
export const deleteAlbumimages = async (data: object) => {
  const response = await manageAPICall(
    AdminAPI.deleteAlbumimages.url,
    AdminAPI.deleteAlbumimages.method,
    data
  );
  return response;
};
export const fflListByProductCategory = async (data: any) => {
  const response = await manageAPICall(
    AdminAPI.fflListByProductCategory.url,
    AdminAPI.fflListByProductCategory.method,
    data
  );
  return response;
};
export const fflList = async (params: any, callback: any) => {
  const payload = params;
  const response: any = await manageAPICall(AdminAPI.fflList.url, AdminAPI.fflList.method, payload);
  if (response && response.status) {
    callback(response.data);
  }
};
export const fflOptions = (inputValue: string, setDisabled = false, additionalParams = {}) =>
  new Promise((resolve) => {
    const payload = {
      filters: {
        search: inputValue,
        ...(additionalParams ? additionalParams : {}),
      },
      limit: 10,
      sort: { created_at: -1 },
    };
    fflList(payload, (responseData: any) => {
      const listData: any = [];
      responseData.data.forEach(function (element: any) {
        listData.push(getFFLObj(element, setDisabled));
      });
      resolve(listData);
    });
  });

// Approved FFLs for pickers that need the whole record (logo, rating, location) and not just
// the id and name that fflOptions keeps.
export const approvedFFLOptions = async (inputValue: string) => {
  const response: any = await manageAPICall(AdminAPI.fflList.url, AdminAPI.fflList.method, {
    filters: { search: inputValue, ffl_verified: APPROVED_STATUS_SLUG },
    limit: 20,
    sort: { business_name: 1 },
  });
  const rows: any[] = response?.status ? (response.data?.data ?? []) : [];
  return rows.map((element: any) => ({
    ...getFFLObj(element),
    logo: element.logo,
    average_rating: element.average_rating,
    total_rating: element.total_rating,
    allow_return_refund: element.allow_return_refund,
    state: element.state,
    city: element.city,
  }));
};

export const fetchFFLBadgeCount = async (): Promise<number> => {
  const response: any = await getFFLCounter();
  if (response) {
    if (response.status) {
      return response.data.pending_ffl || 0;
    }
  }
  return 0;
};

export const getPaymentGatewayList = async () => {
  const response = await manageAPICall(
    AdminAPI.dynamicList.url.replace(':moduleName', 'payment-gateway'),
    AdminAPI.dynamicList.method,
    {}
  );
  return response;
};

export const getShipengineCarriersList = async () => {
  const response = await manageAPICall(
    AdminAPI.dynamicList.url.replace(':moduleName', 'shipengine-carriers'),
    AdminAPI.dynamicList.method,
    {}
  );
  return response;
};

export const executeInviteFFL = async (
  data: any,
  setLoading: (loading: boolean) => void,
  onSuccess?: () => void
) => {
  try {
    setLoading(true);
    const response: any = await manageAPICall(
      AdminAPI.inviteFFL.url,
      AdminAPI.inviteFFL.method,
      data
    );
    setLoading(false);

    if (response?.status) {
      if (onSuccess) onSuccess();
      return true;
    } else {
      notify.error(response?.message ?? t('something_went_wrong'));
      return false;
    }
  } catch (err: any) {
    setLoading(false);
    notify.error(err.message ?? t('something_went_wrong'));
    return false;
  }
};

export const sendIntegrationRequest = async (data: object) => {
  const response = await manageAPICall(
    AdminAPI.sendIntegrationRequest.url,
    AdminAPI.sendIntegrationRequest.method,
    data
  );
  return response;
};
